export const RADIUS_VPN_PREFIX = "/api/vpn/radius_vpn_servers/";
